module.exports = __webpack_public_path__ + "static/media/btn_remove_nor.078c1ba7.svg";